'use client';

import * as React from 'react';
import { styled } from '@linaria/react';

import CheckboxBtn from './CheckboxBtn';

function EraserExplanation() {
  const [firstEnabled, setFirstEnabled] = React.useState(true);
  const [secondEnabled, setSecondEnabled] = React.useState(false);
  const [thirdEnabled, setThirdEnabled] = React.useState(false);

  return (
    <Wrapper>
      <Svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <ShadowPath
          d="m7 21-4.3-4.3c-1-1-1-2.5 0-3.4l9.6-9.6c1-1 2.5-1 3.4 0l5.6 5.6c1 1 1 2.5 0 3.4L13 21"
          stroke="var(--color-gray-200)"
        />
        <ShadowPath d="M22 21H3" stroke="var(--color-gray-200)" />
        <ShadowPath d="m5 11 9 9" stroke="var(--color-gray-200)" />
        {firstEnabled && (
          <BrightPath
            d="m7 21-4.3-4.3c-1-1-1-2.5 0-3.4l9.6-9.6c1-1 2.5-1 3.4 0l5.6 5.6c1 1 1 2.5 0 3.4L13 21"
            stroke="var(--color-text)"
          />
        )}
        {secondEnabled && (
          <BrightPath d="m5 11 9 9" stroke="var(--color-text)" />
        )}
        {thirdEnabled && (
          <BrightPath d="M22 21H2" stroke="var(--color-text)" />
        )}
      </Svg>
      <Actions>
        <Button
          color="var(--color-first)"
          label="Path A"
          isEnabled={firstEnabled}
          onToggle={setFirstEnabled}
        />
        <Button
          color="var(--color-second)"
          label="Path B"
          isEnabled={secondEnabled}
          onToggle={setSecondEnabled}
        />
        <Button
          color="var(--color-third)"
          label="Path C"
          isEnabled={thirdEnabled}
          onToggle={setThirdEnabled}
        />
      </Actions>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  --color-first: hsl(40deg 60% 70%);
  --color-second: hsl(240deg 30% 80%);
  --color-third: hsl(120deg 50% 70%);

  width: 550px;
  max-width: 100%;
  margin-inline: auto;
  margin-top: 2rem;
  margin-bottom: 4rem;
  padding: 16px;
  border-radius: 16px;

  html[data-color-mode='dark'] & {
    outline: 1px solid var(--color-gray-200);
  }
  html[data-color-mode='light'] & {
    box-shadow:
      0px 1px 2px hsl(0deg 0% 0% / 0.1),
      0px 2px 4px hsl(0deg 0% 0% / 0.1),
      0px 8px 16px hsl(0deg 0% 0% / 0.1),
      0px 24px 48px hsl(0deg 0% 0% / 0.1);
  }
`;

const Svg = styled.svg`
  display: block;
  width: 128px;
  height: 128px;
  margin-inline: auto;
`;

const ShadowPath = styled.path`
  stroke: var(--color-gray-200);
`;

const BrightPath = styled.path`
  --color-bright: hsl(160deg 100% 50%);
  stroke: var(--color-text);
  animation:
    fadeFromBright 600ms ease-in-out 300ms both,
    fadeFromTransparent 300ms ease-in-out;

  html[data-color-mode='light'] & {
    --color-bright: hsl(160deg 100% 30%);
  }

  @keyframes fadeFromBright {
    from {
      stroke: var(--color-bright);
    }
  }
`;

const Actions = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 24px;
`;
const Button = styled(CheckboxBtn)`
  flex: 1;
`;

export default EraserExplanation;
